module.exports = __webpack_public_path__ + "img/ico_cjbk.0ebb1729.png";